<template>
  <div class="content">
    <!-- <img src="../assets/career_banner.png" style="width:100%;height:100%;margin-bottom:-8px;"> -->
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Company</el-breadcrumb-item>
      <el-breadcrumb-item>Career</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="message" style="padding-bottom: 0px;">
      <h2>Career</h2>
      <p>Kelliop’s RapidSeq126 platform is an affordable, real-time, quantitative DNA/RNA analysis system that can serve as the basis for rapid detection, quantification of diseases and pathogens. As we further develop our Point-of-care solutions through assay development and product refinement, we have an opportunity to reach millions of people who can benefit from point-of-care molecular diagnostic technology. Ultimately, Kelliop has the ability to change lives through rapid access to the benefits of molecular diagnostics.</p>
    </div>
    <div class="message">
      <h2>Working for us</h2>
      <p>We are especially interested to hear from you if you are a Scientist, an Engineer, or a Clinical Expert (ranging from Junior to Senior level) with experience of manufacturing/designing molecular assays, microfluidics, embedded system, software development, and regulatory affairs.</p>
      <p>If you are interested in joining our team, please send your CV to a@kelliop.com with a brief description of the type of role you are looking for, or how you believe you could contribute to our team and we will be in touch.</p>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'Careers',
        data () {
            return {

            }
        },
        mounted() {
        },
    }
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
}
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
.message {
  padding: 50px 119px 100px 119px;
}
.message h2 {
  margin-bottom: 57px;
  color: #000000;
  font-size: 30px;
  font-weight: bold;
}
.message p {
  margin-bottom: 45px;
  color: #343434;
  font-size: 16px;
  line-height: 30px;
}
::v-deep .el-breadcrumb__inner.is-link {
  font-weight: 400;
}
</style>